(function () {
  function mount(container) {
    if (!container || container.dataset.ycjMounted) return;
    container.dataset.ycjMounted = '1';

    var html = window.__ycjWelcomeHTML || '';
    html = html
      .replace(/__YCJ_WELCOME_PIGEON_URL__/g, container.dataset.pigeon || '')
      .replace(/__YCJ_WELCOME_DOG_URL__/g, container.dataset.dog || '');

    container.innerHTML = html;
  }

  function welcomeToggle(banner) {
    if (!banner) return;
    if (banner.classList.contains('aw-on')) {
      banner.classList.remove('aw-on');
      ['aw-cloud', 'aw-pigeon'].forEach(function (id) {
        var el = banner.querySelector('#' + id);
        if (el) { var c = el.cloneNode(true); el.parentNode.replaceChild(c, el); }
      });
    } else {
      banner.classList.add('aw-on');
    }
  }

  window.YcjAnimatedWelcome = {
    mount: mount,
    toggle: welcomeToggle
  };

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ycj-newsletter-onboarding__welcome-wrap[data-dog]').forEach(mount);
  });
})();
